export default "__VITE_ASSET__cfmSkpVu__"